import React, { createContext, useContext, useState } from 'react';

interface SEOData {
  title: string;
  description: string;
  canonicalUrl: string;
  noIndex?:boolean;
}

type SEOContextType = {
  seo: SEOData;                          // keeps noIndex optional
  setSEO: (patch: Partial<SEOData>) => void; // ergonomic partial updates
};
  

const SEOContext = createContext<SEOContextType>({
  seo: { title: '', description: '', canonicalUrl: '' }, // noIndex omitted
  setSEO: () => {},
});

export const useSEO = () => useContext(SEOContext);    
 

export const SEOProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [seo, _setSEO] = useState<SEOData>({
    title: '',
    description: '',
    canonicalUrl: '',
    // noIndex intentionally omitted
  });

  const setSEO: SEOContextType['setSEO'] = (patch) => {
    _setSEO(prev => ({ ...prev, ...patch }));
  };


 
return (
  <SEOContext.Provider value={{ seo, setSEO }}>
    {children}
  </SEOContext.Provider>
)

};
